import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  invitation_auto_accept_days: false,
  is_nominee_management_enabled: false,
};

const flags = createSlice({
  name: 'flags',
  initialState,
  reducers: {
    setAutoInvitationDays: (state, action) => {
      state.invitation_auto_accept_days = action.payload.invitation_auto_accept_days;
    },
    setIsNomineeManagementEnabled: (state, action) => {
      state.is_nominee_management_enabled = action.payload.is_nominee_management_enabled;
    },
  },
});

export const flagActions = flags.actions;

export default flags.reducer;
